import { useTranslation } from 'next-i18next'

import SVGImage from '~/components/Image/SVGImage'

import MultGameTableItem from './MultGameTableItem'

interface Tables {
  [key: string]: {
    score: number
    accuracy: number
  }
}

interface Props {
  tables: Tables
}
interface TableItem {
  tableNo: string
  score: number
  accuracy: number
}

const generateTableData = (tables: Tables): TableItem[] => {
  const table: TableItem[] = []

  // eslint-disable-next-line fp/no-loops
  for (let i = 0; i <= 10; i++) {
    const tableNo = String(i)
    const tableItem: TableItem = {
      tableNo,
      score: tables[tableNo] ? tables[tableNo].score : 0,
      accuracy: tables[tableNo] ? tables[tableNo].accuracy : 0,
    }
    table.push(tableItem)
  }

  return table
}

export default function MultGameTableStats({ tables }: Props): React.ReactElement {
  const { t } = useTranslation('statistics')
  const allTableData = generateTableData(tables)
  return (
    <div>
      <div className="flex items-center justify-center mb-4">
        <SVGImage alt={t('multGame.table-master')} srcKey="scoreboard/table-master.svg" width={20} />
        <span className="text-md lg:text-lg ml-4 font-medium lg:font-semibold">{t('multGame.table-master')}</span>
      </div>
      {allTableData.map((tableRow) => (
        <MultGameTableItem
          accuracy={tableRow.accuracy}
          key={tableRow.tableNo}
          score={tableRow.score}
          tableNo={tableRow.tableNo}
        />
      ))}
    </div>
  )
}
